import { createContext } from "react";

export const PrefixContext = createContext({ prefix: "", limited: true });
